// Copyright (c) 2024 Visual Intelligence LP. All rights reserved.
//
import { RepoTokenDTO } from '@shared/models/document-repo';
import { ITwinsProjectDTO } from '@shared/models/itwins';
//import { RepoTokenDTO } from '@shared/models/sp-sheets';
import { errObj2Str } from '@shared/utils/common';
import Axios, { AxiosResponse } from 'axios';
import { injectable } from 'inversify';

@injectable()
export default class ITwinsService {
  static diToken = Symbol('itwin-service');

  protected urltoken = 'itwin/token';           // Get the access_token from the authorization_code
  protected urlRenewToken = 'itwin/renewtoken'; // Get the access_token from the refresh_token
  protected urltowers = 'itwin/towers';
  protected urlprojects = 'itwin/projects';

  // Send a request to portal-api (proxy) to get a token from the Bentley OAuth server.
  async getToken(code: string): Promise<RepoTokenDTO> {
    try {
      console.log("****** Get token for code:", code);
      const { data } = await Axios.post<RepoTokenDTO>(this.urltoken, code);
      console.log("****** token:", data);

      if(data) {
        // Set expiration time.
        data.validTill = Math.floor(new Date().getTime() / 1000) + data.expires_in;
        data.authCode = code;
      }

      return data;
    } 
    catch (err) {
      console.error("****** get token failed:", errObj2Str(err));
      throw err;
    }
  }

  // Send a request to portal-api to renew the access_token (using the refresh_token)
  async renewToken(refreshToken: string): Promise<RepoTokenDTO> {
    try {
      console.log("****** Renew access_token from refresh_token", refreshToken);
      const { data } = await Axios.post<RepoTokenDTO>(this.urlRenewToken, refreshToken);
      console.log("****** renewed token:", data);

      if(data) {
        // Set expiration time.
        data.validTill = Math.floor(new Date().getTime() / 1000) + data.expires_in;

        // Update the refresh_token
        if (!data.refresh_token) {
          data.refresh_token = refreshToken;
        }
      }

      return data;
    } 
    catch (err) {
      console.error("****** Renewing token failed:", errObj2Str(err));
      throw err;
    }
  }

  // Send a request to portal-api to get a list of towers from Bentley api server.
  async getTowers(): Promise<Array<ITwinsProjectDTO>> {
    let response: AxiosResponse<ITwinsProjectDTO[], any>;
    try {
      console.log("****** Get towers.")
      response = await Axios.get<Array<ITwinsProjectDTO>>(this.urltowers);

      const { data } = response;
      console.log("****** tower list:", data);
      return data;
    } 
    catch (err) {
      console.error("****** get towers failed:", errObj2Str(err));
      throw err;
    }
  }


  // Send a request to portal-api to get a list of projects from Bentley api server.
  async getProjects(): Promise<Array<ITwinsProjectDTO>> {
    let response: AxiosResponse<ITwinsProjectDTO[], any>;
    try {
      console.log("****** Get towers.")
      response = await Axios.get<Array<ITwinsProjectDTO>>(this.urlprojects);

      const { data } = response;
      console.log("****** tower list:", data);
      return data;
    } 
    catch (err) {
      console.error("****** get towers failed:", errObj2Str(err));
      throw err;
    }
  }

}